import axios from 'axios'
import { toast } from 'react-toastify';

export const LocalbackendUrl = "http://localhost:1337/api";
export const baseUrl=process.env.REACT_APP_SERVER
export const prodUrl=process.env.REACT_APP_PROD_URL
export const devUrl=process.env.REACT_APP_DEV_URL

export const axiosStrapiInstance = axios.create({
  baseURL:baseUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

const studentToken=process.env.REACT_APP_STUDENT_TOKEN
const publicToken=process.env.REACT_APP_PUBLIC_TOKEN

axiosStrapiInstance.interceptors.request.use(
  (config,privateToken) => {
    const token = config.privateToken ? studentToken :  publicToken;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.log('error',error);
    return Promise.reject(error);
  }
);

// axiosStrapiInstance.interceptors.response.use(
//   (response) => {
//     // If you need to process or log the response data
//     console.log('Response received:', response);

//     // You can also check for specific conditions (e.g., if the token is expired, etc.)
//     if (response.data && response.data.error) {
//       // Handle specific error scenarios, like a token expiration or other custom error responses
//       console.error('Error in response:', response.data.error);
//     }

//     // Return the response data as is, or manipulate it if necessary
//     return response;
//   },
//   (error) => {
//     // Handle errors in the response (e.g., network error, invalid status code)
//     console.log('Response Error:', error);
   

//     // You can check if it's a network error or a specific HTTP error code
//     if (error.response && error.response.status === 401) {
//       // Example: Handle unauthorized access (401), like refreshing the token
//       console.log('Unauthorized access, maybe refresh the token');
//     }

//     if(error.response && error.response.status === 502)
//     {
//       toast.error("Timeout,Please try Again")
//     }

//     // Always reject the promise so it can be caught in the calling code
//     return Promise.reject(error);
//   }
// );


export default axiosStrapiInstance;